const Main = () => import('@pages/main/Main')
const Input = () => import('@pages/main/tabs/Input')
const InputEdit = () => import('@pages/main/tabs/Input/InputEdit')
const User = () => import('@pages/main/tabs/User')

export const main = [
  {
    path: '/',
    redirect: '/input',
    component: Main,
    meta: {},
    children: [
      {
        path: '/input',
        name: 'Input',
        component: Input,
        meta: {}
      },
      {
        path: '/input/:id',
        name: 'InputEdit',
        component: InputEdit,
        meta: {}
      },
      {
        path: '/user',
        name: 'User',
        component: User,
        meta: {}
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/main.route.js